export const delayDefaults = {
  DELAY: 2000,
  ANIMATION_DURATION: 0
};
